// Module
var code = "<!-- Border layout -->\n<cjs-border-layout class=\"border-layout-100vh\" ref=\"appLayout\">\n\n    <!-- Header-->\n    <nav-header ref=\"navHeader\" slot=\"top\" class=\"w-100\"></nav-header>\n\n    <!-- Pages -->\n    <div slot=\"center\" ref=\"pagesContainer\" class=\"w-100 h-100 p-2\"></div>\n\n\n\n</cjs-border-layout>";
// Exports
module.exports = code;